import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, tap, withLatestFrom } from 'rxjs/operators';

import * as FormActions from '@shared/form/store/form.actions';

import { getUploadCandidateId } from '../../store';
import { CandidateUploadComponent } from '../upload/candidate-upload.container';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadModalContainerComponent implements OnDestroy {
  subscription: Subscription;

  constructor(private store: Store<{}>, private router: Router) {
    this.subscription = this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        filter((event: NavigationEnd) =>
          event.urlAfterRedirects.includes('(modal:candidate')
        ),
        withLatestFrom(this.store.pipe(select(getUploadCandidateId))),
        tap(([, candidateId]: [any, number]) =>
          this.store.dispatch(
            FormActions.formOpen({
              formState: {
                component: CandidateUploadComponent,
                data: {
                  header: !candidateId ? 'Add a candidate' : 'Edit a candidate',
                  panelClass: 'medium-size-modal'
                }
              }
            })
          )
        )
      )
      .subscribe();
  }

  ngOnDestroy() {
    return !!this.subscription && this.subscription.unsubscribe();
  }
}
